import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Download, FileText, Loader2 } from "lucide-react";
import { companyReceipts } from "../../api/platform";

const API = process.env.REACT_APP_BACKEND_URL;
// Receipts stored for this company, each with an instant download link.
export const CompanyReceipts = ({ companyId }) => {
  const { t } = useTranslation();
  const [items, setItems] = useState(null);
  const [busy, setBusy] = useState(false);

  const open = async () => {
    setBusy(true);
    try {
      setItems(await companyReceipts(companyId));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mt-4 border-t border-border/60 pt-3">
      {items === null ? (
        <button
          type="button"
          data-testid={`company-receipts-open-${companyId}`}
          onClick={open}
          disabled={busy}
          className="flex items-center gap-2 text-xs font-bold text-primary"
        >
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <FileText className="h-4 w-4" />}
          {t("platform.receipts")}
        </button>
      ) : items.length === 0 ? (
        <p className="text-xs text-muted-foreground" data-testid={`company-receipts-empty-${companyId}`}>
          {t("platform.receiptsEmpty")}
        </p>
      ) : (
        <ul className="space-y-1.5" data-testid={`company-receipts-${companyId}`}>
          {items.map((r) => (
            <li key={r.token} className="flex items-center justify-between gap-2 text-xs">
              <span className="truncate font-mono text-muted-foreground">
                {(r.created_at || "").slice(0, 10)}
              </span>
              <a
                href={`${API}/api/receipts/${r.token}`}
                target="_blank"
                rel="noreferrer"
                data-testid={`receipt-download-${r.token}`}
                className="flex shrink-0 items-center gap-1 rounded-xl px-2 py-1 font-bold text-primary shadow-neu-sm hover:shadow-neu-in"
              >
                <Download className="h-3.5 w-3.5" />
                PDF
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
